import styled from 'styled-components';
import cssKit from '../../../../css'; //eslint-disable-line

export const StyledVehiclePrice = styled.div`
  width: 200px;
`;

export const StyledPriceMeta = styled.div`
  margin-bottom: 1.5rem;
`;

export const StyledVehicleBoxButton = styled.button`
  display: block;
  height: 100%;
  width: 100%;
`;

export const StyledVehicleBox = styled.div`
  margin-bottom: 4rem;
`;

export const StyledActionButton = styled.button`
  display: block;
  height: 100%;
  width: 100%;
  margin-bottom: 0;
  font-size: 1rem;
`;




/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/VehicleGrid/VehicleTile/infiniti-styles.js
 **/